<div class="tab-data-container">
	@if (!requestData.relatedArticles || requestData.relatedArticles.length === 0) {
		<div class="article">
			{{ labels.lbl_geral_sem_artigos_relacionados }}
		</div>
	}
	@for (article of requestData.relatedArticles; track $index) {
		<div class="article">
			<span class="title p-1">{{ article.id }} - {{ article.summary }}</span>
			<a target="_blank" [routerLink]="'/knowledgebase/read/' + article.id"><fa-icon [icon]="icons.faExternalLinkAlt"></fa-icon></a>
		</div>
	}
</div>
